module.exports = __webpack_public_path__ + "img/1.6a4808f8.jpg";